import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconSparkles, IconTextPlus } from '@tabler/icons-react';
import * as React from 'react';

import CopyActionButton from '@/components/shared/CopyActionButton';
import PrintActionButton from '@/components/shared/PrintActionButton';
import { useDevices } from '@/utils/devices';

const disabledActionIconStyles = {
  root: {
    backgroundColor: 'var(--mantine-color-gray-1)',
    color: 'var(--mantine-color-gray-5)',
  },
};

type QuickThoughtsActionsProps = {
  onCreateNote: () => void;
  onCreateInsight: () => void;
  disableNote?: boolean;
  disableInsight?: boolean;
  onCopy?: () => void;
  onPrint?: () => void;
  className?: string;
};

const QuickThoughtsActions: React.FC<QuickThoughtsActionsProps> = ({
  onCreateNote,
  onCreateInsight,
  disableNote = false,
  disableInsight = false,
  onCopy,
  onPrint,
  className,
}) => {
  const { isCompactViewport } = useDevices();

  return (
    <Group className={className} gap="sm" wrap={isCompactViewport ? 'nowrap' : 'wrap'} align="center">
      <Tooltip label="Добавить заметку" position="bottom">
        <ActionIcon
          variant="light"
          size="lg"
          radius="md"
          onClick={onCreateNote}
          disabled={disableNote}
          styles={disableNote ? disabledActionIconStyles : undefined}
          aria-label="Добавить заметку"
        >
          <IconTextPlus size={18} />
        </ActionIcon>
      </Tooltip>
      <Tooltip label="Создать инсайт" position="bottom">
        <ActionIcon
          variant="light"
          size="lg"
          radius="md"
          onClick={onCreateInsight}
          disabled={disableInsight}
          aria-label="Создать инсайт"
        >
          <IconSparkles size={18} />
        </ActionIcon>
      </Tooltip>
      {onCopy && (
        <Tooltip label="Скопировать" position="bottom">
          <CopyActionButton size={32} variant="light" onCopy={onCopy} aria-label="Скопировать текст" />
        </Tooltip>
      )}
      {onPrint && (
        <Tooltip label="Распечатать" position="bottom">
          <PrintActionButton size={32} variant="light" onClick={onPrint} />
        </Tooltip>
      )}
    </Group>
  );
};

export default React.memo(QuickThoughtsActions);
